export function getCurrentPath(){
    const routes= window.location.pathname.split('/');
    return routes[routes.length-1];
}